import React, { useEffect, useState } from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import { fetchSupervisorBankReport } from '../../api/supervisor';
import { downloadCSV } from '../../utils/csv';
import './SupervisorBankReportPage.css';

const SupervisorBankReportPage = () => {
  const [blocks, setBlocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    fetchSupervisorBankReport()
      .then((data) => { if (!cancelled) setBlocks(data); })
      .catch(() => { if (!cancelled) setError('Impossible de charger le rapport.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const handleDownload = () => {
    if (blocks.length === 0) return;
    const rows = [['Rapport du Banque'], []];
    blocks.forEach((block) => {
      rows.push(['ID', 'Banque', 'Adresse']);
      rows.push([block.seq, block.name, block.address]);
      if (block.terminals?.length) {
        rows.push(['ID', 'Terminal', 'Nom', 'Adresse', 'Téléphone', 'Statut']);
        block.terminals.forEach((t) => rows.push([t.id ?? '', t.terminal, t.nom, t.adresse || '', t.telephone || '', t.actif === false ? 'Inactif' : 'Actif']));
      }
      rows.push([]);
    });
    downloadCSV('rapport-du-banque.csv', rows);
  };

  return (
    <SupervisorLayout>
      <div className="svbr-header">
        <h2 className="svbr-title">Rapport du Banque</h2>
        {blocks.length > 0 && (
          <button type="button" className="svbr-download-btn" onClick={handleDownload}>Télécharger</button>
        )}
      </div>

      {error && <p className="svbr-error">{error}</p>}
      {loading ? (
        <p>Chargement...</p>
      ) : blocks.length === 0 ? (
        <p className="svbr-empty">Aucun groupe.</p>
      ) : (
        blocks.map((block) => (
          <div key={block.id ?? 'sans-groupe'} className="svbr-block">
            <p className="svbr-block-title">{block.name}{block.address ? ` — ${block.address}` : ''}</p>
            {block.terminals?.length > 0 ? (
              <table className="svbr-table">
                <thead><tr><th>ID</th><th>Terminal</th><th>Nom</th><th>Adresse</th><th>Téléphone</th><th>Statut</th></tr></thead>
                <tbody>
                  {block.terminals.map((t, i) => (
                    <tr key={i}><td>{t.id ?? ''}</td><td>{t.terminal || '—'}</td><td>{t.nom}</td><td>{t.adresse || '.'}</td><td>{t.telephone || '.'}</td><td>{t.actif === false ? 'Inactif' : 'Actif'}</td></tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="svbr-block-empty">Aucun terminal dans ce groupe.</p>
            )}
          </div>
        ))
      )}
    </SupervisorLayout>
  );
};

export default SupervisorBankReportPage;
